import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DataTable from '../../../../Common/DataTable';
import { RootState } from '../../../../redux/rootState';
import { setLoader } from '../../../../redux/loaderSlice';
import ComponentDeleteModal from '../../../../Common/DeleteModal/ComponentDeleteModal';
import { deleteFlaggedKitsStart, getFlaggedKitsStart } from '../redux/sliceFlaggedKits';
import { FlaggedKits } from '../utils/types';
import ComponentFlaggedKitsDialog from './ComponentFlaggedKitsDialog';

function ComponentFlaggedKitsTable() {
  const [open, setOpen] = useState(false);
  const [rowId, setRowId] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedFlaggedKitsId, setSelectedFlaggedKitsId] = useState<string>('');
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState('');
  const dispatch = useDispatch();

  const { isLoading, FlaggedKitsData } = useSelector((state: RootState) => state.FlaggedKitsReducer);

  const handleData = () => {
    const params = {
      page,
      rowsPerPage,
      searchQuery,
    };
    dispatch(getFlaggedKitsStart(params));
  };

  const handleAction = (id: string) => {
    setOpen(true);
    setRowId(id);
  };

  const handleButtonClick = () => {
    setRowId('');
    setOpen(!open);
  };

  useEffect(() => {
    dispatch(setLoader(isLoading));
  }, [isLoading]);

  const TableColumns = useMemo(
    () => [
      // { key: 'sn', label: 'SN' },
      { key: 'action', label: 'Action' },
      { key: 'kitNo', label: 'Kit #' },
    ],
    [],
  );

  const tableData: FlaggedKits[] = useMemo(() => FlaggedKitsData?.Data?.map((item, index) => {
    const transformedDataItem = {
      sn: index,
      action: 'edit&delete',
      kitNo: item?.Text,
      id: String(item?.Value),
    };
    return transformedDataItem;
  }), [FlaggedKitsData]);

  const handleDelete = (id: string) => {
    setShowDeleteModal(true);
    setSelectedFlaggedKitsId(id);
  };

  const handelDeleteModal = () => {
    const selectedRow = tableData?.find((item) => item?.id === selectedFlaggedKitsId);
    const paramData = {
      pay: {
        kitNo: selectedRow?.kitNo || '',
        delete: true,
      },
      page,
      rowsPerPage,
      searchQuery,
    };
    dispatch(deleteFlaggedKitsStart(paramData));
    setShowDeleteModal(false);
  };

  return (
    <>
      <DataTable<FlaggedKits>
        handleButtonClick={handleButtonClick}
        data={tableData}
        columns={TableColumns}
        totalRecords={FlaggedKitsData?.TotalRecords}
        buttonText="Add"
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        handleData={handleData}
        handleEdit={handleAction}
        handleDelete={handleDelete}
      />
      <ComponentFlaggedKitsDialog show={open} setOpenFrom={handleButtonClick} rowId={rowId} handleData={handleData} />
      <ComponentDeleteModal
        show={showDeleteModal}
        setOpenFrom={() => setShowDeleteModal(false)}
        handleDelete={handelDeleteModal}
      />
    </>
  );
}

export default ComponentFlaggedKitsTable;
